module.exports = __webpack_public_path__ + "static/media/nasa1.1f3da24b.png";